// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__2_93E","spin":"Spinner_spin__3aHr1","white":"Spinner_white__2w0AP","small":"Spinner_small__2BIB_","medium":"Spinner_medium__2WMlI"};